import * as z from 'zod';

export const DateTypeSchema = z.string().or(z.number()).or(z.date());
export type DateType = string | number | Date;

export type UnitOfTime = 'minute' | 'hour';

export const IntervalSchema = z.object({
  start: DateTypeSchema,
  end: DateTypeSchema,
});
export interface Interval {
  /**
   * Date representation of when the interval starts
   */
  start: DateType;
  /**
   * Date representation of when the interval ends
   */
  end: DateType;
}

export type Duration = Interval | number;
